import { Trade, useTradeFormCreateMutation } from 'generated/graphql';
import React, { FunctionComponent, useCallback } from 'react';

import { mapTradeGroupsFormValuesToTradeGroupObjects } from './map-trade-groups-form-values-to-trade-group-objects';
import TradesFormCreateContainer from './trade-form-create-container';

export type TradeCreate = Pick<
  Trade,
  | 'name'
  | 'slug'
  | 'pageTitle'
  | 'anchor'
  | 'pageTitleVariant'
  | 'pageSubtitle'
  | 'pageTitleDirectory'
  | 'label'
  | 'metaTitle'
  | 'metaDescription'
  | 'isAnonymised'
  | 'isCallRecordable'
  | 'isRgeFilterable'
  | 'schemaType'
  | 'schemaAdditionalType'
> & { tradeGroups: number[] };

const TradesFormCreateRepository: FunctionComponent = () => {
  const [insertTradeOne] = useTradeFormCreateMutation();

  const createTrade = useCallback(
    async (trade: TradeCreate) =>
      insertTradeOne({
        variables: {
          trade: {
            name: trade.name,
            slug: trade.slug,
            pageTitle: trade.pageTitle,
            anchor: trade.anchor,
            pageTitleVariant: trade.pageTitleVariant,
            pageSubtitle: trade.pageSubtitle,
            pageTitleDirectory: trade.pageTitleDirectory,
            label: trade.label,
            metaTitle: trade.metaTitle,
            metaDescription: trade.metaDescription,
            isAnonymised: trade.isAnonymised,
            isCallRecordable: trade.isCallRecordable,
            isRgeFilterable: trade.isRgeFilterable,
            schemaType: trade.schemaType,
            schemaAdditionalType: trade.schemaAdditionalType,
            tradeGroups: {
              data: [
                ...mapTradeGroupsFormValuesToTradeGroupObjects(
                  trade.tradeGroups,
                ),
              ],
            },
          },
        },
      }),
    [insertTradeOne],
  );

  return <TradesFormCreateContainer createTrade={createTrade} />;
};

export default TradesFormCreateRepository;
